import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

export const ImageContainer = styled.div`
  text-align: center;
  max-width: 100%;
  height: auto;
`;
export const ImageElementSimple = styled.img`
  border-radius: 16px;
  max-width: calc(100% - 10px);
  margin-right: 10px;
  margin-left: 6px;
  margin-top: 9px;
  height: auto;
  @media (max-width: 768px) {
    border-radius: 0px;
    margin-top: 0px;
  }
`;
export const ImageElement = styled.img`
  border-radius: 16px;
  height: ${(props) => props.height};
  width: ${(props) => props.width ?? "auto"};

  object-fit: ${(props) => props.objectFit};
`;
export const CommitmentImageRight = styled.img`
  position: relative;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  object-fit: cover;
  width: 442px;
  min-height: 320px;
  height: 100%;
  right: 0;
  float: right;
  @media (max-width: 1200px) {
    border-top-left-radius: 16px;
    border-bottom-right-radius: 0px;
    width: 100%;
    height: unset;
  }
  @media (max-width: 768px) {
    height: unset;
  }
  @media (max-width: 600px) {
    ${(props) =>
      props.mobileInverted &&
      `
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 16px;
      border-bottom-left-radius: 16px;
    `}
  }
`;
export const CommitmentImageLeft = styled.img`
  position: relative;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  object-fit: cover;
  width: 442px;
  min-height: 320px;
  height: 100%;
  left: 0px;
  float: left;
  @media (max-width: 1200px) {
    border-top-right-radius: 16px;
    border-bottom-left-radius: 0px;
    width: 100%;
    height: unset;
  }
  @media (max-width: 768px) {
    height: unset;
  }
  @media (max-width: 600px) {
    ${(props) =>
      props.mobileInverted &&
      `
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 16px;
      border-bottom-left-radius: 16px;
    `}
  }
`;
export const CommitmentImageContainer = styled(Grid)`
  position: relative;
  min-height: 320px;
  width: 442px;
  display: block;
  flex: 1;
  @media (max-width: 1200px) {
    border-top-left-radius: 16px;
    border-bottom-right-radius: 0px;
    width: 100%;
    height: unset;
  }
  @media (max-width: 768px) {
    height: unset;
  }
`;
export const CommitmentImage = ({ ...props }) => {
  return props.reverse ? (
    <CommitmentImageRight
      src={props.src}
      mobileInverted={props.mobileInverted}
    />
  ) : (
    <CommitmentImageLeft
      src={props.src}
      mobileInverted={props.mobileInverted}
    />
  );
};
CommitmentImage.propTypes = {
  reverse: PropTypes.any,
  src: PropTypes.any,
  mobileInverted: PropTypes.any,
};
